import { render } from "./ProfileAvatarUpdate.vue?vue&type=template&id=27b703bf"
import script from "./ProfileAvatarUpdate.vue?vue&type=script&lang=ts"
export * from "./ProfileAvatarUpdate.vue?vue&type=script&lang=ts"
script.render = render

export default script